import "./styles.css";
import { initializeInteractions } from "./interactions";
import { initializeWaitlistForm } from "./waitlist-client";
import { initializeBrrrrMotion } from "./brrrr-motion";
import { initializePageMotion } from "./page-motion";
import { initializeConsent } from "./consent";
import { initializeAnalytics } from "./analytics";
import { initializePublicNavigation } from "./public-navigation";

const disposeConsent = initializeConsent(document, window);
const disposeAnalytics = initializeAnalytics(document, window);
const disposeNavigation = initializePublicNavigation(document, window);
const disposeInteractions = initializeInteractions(document, window);
const disposeWaitlist = initializeWaitlistForm(document);
const disposeBrrrrMotion = initializeBrrrrMotion(document, window);
const disposePageMotion = initializePageMotion(document, window);
if (import.meta.hot)
  import.meta.hot.dispose(() => {
    disposeNavigation();
    disposeInteractions();
    disposeWaitlist();
    disposeBrrrrMotion();
    disposePageMotion();
    disposeAnalytics();
    disposeConsent();
  });
